// extracted by mini-css-extract-plugin
export var active = "menu-sidebar-nav-items-module--active--UrRxa";
export var item = "menu-sidebar-nav-items-module--item--s1Xfk";
export var text = "menu-sidebar-nav-items-module--text--PQGIR";